function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { createSelector, createSelectorMemoized } from "../../../utils/createSelector.js";
var gridRowsStateSelector = function(state) {
    return state.rows;
};
export var gridRowCountSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.totalRowCount;
});
export var gridRowsLoadingSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.loading;
});
export var gridTopLevelRowCountSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.totalTopLevelRowCount;
});
// TODO rows v6: Rename
export var gridRowsLookupSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.dataRowIdToModelLookup;
});
export var gridRowsDataRowIdToIdLookupSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.dataRowIdToIdLookup;
});
export var gridRowTreeSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.tree;
});
export var gridRowGroupsToFetchSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.groupsToFetch;
});
export var gridRowGroupingNameSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.groupingName;
});
export var gridRowTreeDepthsSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.treeDepths;
});
export var gridRowMaximumTreeDepthSelector = createSelectorMemoized(gridRowsStateSelector, function(rows) {
    var entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) {
        return 1;
    }
    var _entries_filter_map_sort_;
    return ((_entries_filter_map_sort_ = entries.filter(function(param) {
        var _param = _sliced_to_array(param, 2), nodeCount = _param[1];
        return nodeCount > 0;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 1), depth = _param[0];
        return Number(depth);
    }).sort(function(a, b) {
        return b - a;
    })[0]) !== null && _entries_filter_map_sort_ !== void 0 ? _entries_filter_map_sort_ : 0) + 1;
});
export var gridDataRowIdsSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows.dataRowIds;
});
/**
 * @ignore - do not document.
 */ export var gridAdditionalRowGroupsSelector = createSelector(gridRowsStateSelector, function(rows) {
    return rows === null || rows === void 0 ? void 0 : rows.additionalRowGroups;
});
/**
 * @ignore - do not document.
 */ export var gridPinnedRowsSelector = createSelectorMemoized(gridAdditionalRowGroupsSelector, function(additionalRowGroups) {
    var _rawPinnedRows_bottom, _rawPinnedRows_top;
    var rawPinnedRows = additionalRowGroups === null || additionalRowGroups === void 0 ? void 0 : additionalRowGroups.pinnedRows;
    var _rawPinnedRows_bottom_map, _rawPinnedRows_top_map;
    return {
        bottom: (_rawPinnedRows_bottom_map = rawPinnedRows === null || rawPinnedRows === void 0 ? void 0 : (_rawPinnedRows_bottom = rawPinnedRows.bottom) === null || _rawPinnedRows_bottom === void 0 ? void 0 : _rawPinnedRows_bottom.map(function(rowEntry) {
            var _rowEntry_model;
            return {
                id: rowEntry.id,
                model: (_rowEntry_model = rowEntry.model) !== null && _rowEntry_model !== void 0 ? _rowEntry_model : {}
            };
        })) !== null && _rawPinnedRows_bottom_map !== void 0 ? _rawPinnedRows_bottom_map : [],
        top: (_rawPinnedRows_top_map = rawPinnedRows === null || rawPinnedRows === void 0 ? void 0 : (_rawPinnedRows_top = rawPinnedRows.top) === null || _rawPinnedRows_top === void 0 ? void 0 : _rawPinnedRows_top.map(function(rowEntry) {
            var _rowEntry_model;
            return {
                id: rowEntry.id,
                model: (_rowEntry_model = rowEntry.model) !== null && _rowEntry_model !== void 0 ? _rowEntry_model : {}
            };
        })) !== null && _rawPinnedRows_top_map !== void 0 ? _rawPinnedRows_top_map : []
    };
});
/**
 * @ignore - do not document.
 */ export var gridPinnedRowsCountSelector = createSelector(gridPinnedRowsSelector, function(pinnedRows) {
    var _pinnedRows_top, _pinnedRows_bottom;
    return ((pinnedRows === null || pinnedRows === void 0 ? void 0 : (_pinnedRows_top = pinnedRows.top) === null || _pinnedRows_top === void 0 ? void 0 : _pinnedRows_top.length) || 0) + ((pinnedRows === null || pinnedRows === void 0 ? void 0 : (_pinnedRows_bottom = pinnedRows.bottom) === null || _pinnedRows_bottom === void 0 ? void 0 : _pinnedRows_bottom.length) || 0);
});
